<form>
  <mat-form-field>
    <div class="input">
      <div class="label">
        <span style="color: #e00000; margin-right: 5px">*</span>{{ label }}：
      </div>
      <mat-form-field>
        <input
          matInput
          [placeholder]="placeholder"
          [formControl]="formControl"
          name="uniqueName"
        />
      </mat-form-field>
    </div>
    <mat-error *ngIf="formControl.hasError('required')">{{
      errorText
    }}</mat-error>
  </mat-form-field>
</form>
